import { Typography } from "@mui/material";
import type { Bank } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  bank: Bank;
};

export const AdditionalInfo = ({ bank }: Props) => {
  const { t } = useResource();

  const additionalInfo = t(Resources.BankRating.Banks[bank].AdditionalInfo);

  if (!additionalInfo) {
    return null;
  }

  return (
    <Typography fontSize="1rem" fontWeight={500}>
      {additionalInfo}
    </Typography>
  );
};
